<div *ngIf="file">
  <div class="container">
    <div class="file-icon">
      <img class="img-icon" [src]="iconType" />
    </div>
    <div class="file-name">
      <span>{{ file.name! }}</span>
    </div>
    <div class="size-status-error">
      <div class="size-status">
        <div class="file-size">
          <span>{{ fileSize(file) }}</span>
        </div>
        <div class="file-status">
          <div *ngIf="uploadError; else noError">
            <div *ngIf="screenWidth>800">
              <div class="desktop-error">
                <span class="desktop-error-text">falha ao carregar.</span>
                <button class="error-text-color" mat-button (click)="onTryAgainClick()">
                  Tentar novamente
                </button>
              </div>
            </div>
          </div>
          <ng-template #noError>
            <div class="file-uploading-status">
              <div class="progress-bar" *ngIf="uploadInProgress; else notInProgess">
                <div>
                  <mat-progress-bar mode="determinate" [value]="progressPercent" ></mat-progress-bar>
                </div>
                <label></label>
              </div>
              <ng-template #notInProgess>
                <div class="status">
                  <div class="status-info">
                    <span>{{ fileStatus }}</span>
                  </div>
              </div>
              </ng-template>
            </div>
          </ng-template>
        </div>
      </div>
      <div *ngIf="uploadError && screenWidth<=800">
        <div class="mobile-error">
          <button class="error-text-color" mat-button (click)="onTryAgainClick()">
            Tentar novamente
          </button>
        </div>
      </div>
    </div>
    <div class="file-upload-cancel-button">
      <div *ngIf="uploadInProgress || uploadError">
        <button mat-icon-button color="warn" aria-label="Cancelar"
          (click)="onStopUploadClick()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
